export const MAX_BASE_RATE_VALUE = 10000;
